<app-website-header></app-website-header>
<div class="main-container d-flex flex-column w-100">

    <div class="welcomeContainer container-fluid d-flex flex-column align-items-center">
        <div class="welcomee row row-cols-lg-2">
            <div class="col-12 col-lg-6 d-flex flex-1 justify-content-center"
                style=" max-width: 700px; max-height:700px; flex-direction: column; margin-left: 10px;">
                <img [src]="carouselImgs[currCarousel] ||'../../../../assets/images/EmptyClinicImage.svg'"
                    class="d-block d-lg-none col-12" style=" border-radius: 20px;   height: 346px;"
                    alt="Clinic Welcome Image">
                <img [src]="carouselImgs[currCarousel] ||'../../../../assets/images/EmptyClinicImage.svg'"
                    class="d-none d-lg-block "  style="width: 700px; height: 700px !important; border-radius: 20px; margin-left: 30px;"
                    alt="Clinic Welcome Image">
                <div class="points">
                    <div class="pointE" (click)="carouselChange(point)"
                        *ngFor="let point of carouselImgs.slice(0, currCarousel)"></div>
                    <div class="pointE" (click)="carouselChange(point)"
                        *ngFor="let point of carouselImgs.slice(0, currCarousel)"></div>
                    <div class="point"></div>
                    <div class="pointE" (click)="carouselChange(point)"
                        *ngFor="let point of carouselImgs.slice(currCarousel+1)"></div>
                </div>
            </div>
            <div class="welcomeClinic col-12 col-xl-6 w-100 w-xl-25 order-1 order-xl-2" style="flex: 1;">
                <div class="lh-sm" style="padding-top: 20px; padding-left: 90px;" ><span class="libra"
                        style="line-height: 20px !important;">WELCOME TO</span><br>
                    <span class="headerName libra" style="margin-top: 1px;">{{clinicsData?.name}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="contact d-flex justify-content-center"
        style="background: linear-gradient(to bottom,#E1F1FF 50%, white 50%);">
        <div class="contact-items">
            <div class="emergency d-flex align-items-center ">
                <img src="../../assets/images/icons/clinic-phone.svg" width="31px" height="31px" alt="">
                <span>
                    <p class="contact-sub-headers libra">Emergency</p>
                    <p class="contact-information" style="cursor: pointer; text-decoration: none; color: #0D6EFD;"
                        (click)="openDialPad(clinicsData?.phoneCode,clinicsData?.phone)">{{clinicsData?.phoneCode}}
                        {{clinicsData?.phone}}</p>
                </span>
            </div>
            <div class="emergency d-flex align-items-center">
                <img src="../../assets/images/icons/clinic-location.svg" width="31px" height="31px" alt="">
                <span>
                    <p class="contact-sub-headers libra">Location</p>
                    <p class="contact-information">{{clinicsData?.address}}</p>
                </span>
            </div>
            <div class="emergency d-flex align-items-center">
                <img src="../../assets/images/icons/clinic-globe.svg" width="31px" height="31px" alt="">
                <span class="">
                    <p class="contact-sub-headers libra">Website</p>
                    <p (click)="openWebsite(clinicsData?.url)"
                        style="cursor: pointer; text-decoration: none;color: #0D6EFD;" class="contact-information">
                        {{clinicsData?.url}}</p>
                </span>
            </div>
            <div class="social-imgs d-flex " style="gap:10px;">
                <img class="social-media-links" (click)="socialNavigations('fb')"
                    src="../../assets/images/icons/hospital-fb.svg" alt="fb" height="20px">
                <img class="social-media-links" (click)="socialNavigations('insta')"
                    src="../../assets/images/icons/hospital-instagram.svg" alt="insta" height="20px">
                <img class="social-media-links" (click)="socialNavigations('linkedin')"
                    src="../../assets/images/icons/hospital-linkedin.svg" alt="linkedin" height="20px">
                <img class="social-media-links" (click)="socialNavigations('x')"
                    src="../../assets/images/icons/twitter-icon1.svg" alt="x" height="20px">

                <div class="d-flex d-lg-none align-items-center justify-content-center qrCode">
                    <img [src]="clinicsData?.qrCodeURL" alt="qr" width="100px" height="100px">
                </div>
            </div>
            <div class="d-none d-lg-flex align-items-center justify-content-center qrCode">
                <img [src]="clinicsData?.qrCodeURL" alt="qr" width="100px" height="100px">
            </div>
        </div>
    </div>

    <div class="serviceContainer">
        <div class="clinicServices">
            <div class="headerTitle col-12 libra" style="line-height: normal;">
                WE PROVIDE OUR
                <div class="headerTitleNext libra">Best Services</div>
            </div>
            <div class="serviceSliderContainer">
                <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left', 'bestServices-container')"
                    [class.disabled]="!canSlideLeftServices" style="cursor: pointer; width: 40px; height: auto;">

                <div class="serviceImagesClinic bestServices-container">
                    <ng-container *ngIf="servicesData.length > 0; else noData">
                        <div *ngFor="let data of servicesData; let i = index" class="static-image col-4 col-md col-lg">
                            <img [src]="data[1]" class="img-fluid d-block d-sm-none" alt="">
                            <img [src]="data[1]" class="d-none d-sm-block d-md-block d-lg-block" width="140px"
                                height="100px" alt="">
                            <p>{{ data[0] }}</p>
                        </div>
                    </ng-container>
                    <ng-template #noData>
                        <p class="to-be-updated servicesUpdateSoon" >To Be Updated Soon</p>
                    </ng-template>                   
                </div>
                <img class="d-none d-sm-block d-lg-block right-arrow" src="assets/images/specialities_right-arrow.svg"
                    alt="Right Arrow" (click)="slide('right', 'bestServices-container')"
                    [class.disabled]="!canSlideRightServices" style="cursor: pointer; width: 40px; height: auto;">
            </div>
        </div>
    </div>


    <div class="whyChooseContainer container-fluid d-flex justify-content-center align-items-center">
        <div class=" whyChooseSubContainer row d-flex flex-row" style="width: 90%; margin: 50px 0;">
            <div class="col-12 col-lg-6 d-flex flex-1 justify-content-center whyImgContainer"
                style=" max-width: 500px;">
                <img [src]="whyChooseUse" class="d-block d-lg-none img-fluid" style=" border-radius: 0 100px;"
                    alt="Clinic Welcome Image">
                <img [src]="whyChooseUse" class="d-none d-lg-block img-fluid "
                    style=" border-radius: 0 100px; height: 659.78px;" alt="Clinic Welcome Image">
            </div>
            <div class="col-lg-6 d-flex flex-column justify-content-center container-fluid">
                <div>
                    <div class="headerTitle libra col-12"
                        style="width: fit-content;margin-bottom:40px;line-height: normal; ">Why Choose Us</div>
                    <p *ngIf="!(about)" class="to-be-updated">To Be Updated Soon</p>
                    <p *ngIf="about" class="about-text col-12" style="margin-bottom:20px; text-align: justify;"
                        [innerHTML]="about"></p>
                    <div class="flex-wrap certificates-container" style="gap:40px; display: flex;">
                        <span *ngFor="let c of clinicsData?.certifications"><img
                                src="../../../../assets/images/Product Details - Certificate Icon.svg" width="35px"
                                height="50px" alt="">&nbsp;{{c?.name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="equipments infrastructure-equipments d-flex flex-column align-items-center"
        *ngIf="infras?.length !== 0">
        <div class="heading p-3 p-md-4 text-center">
            <h2 class="libra ">WE PROVIDE CUTTING EDGE</h2>
            <span class="contact-heading libra">Infrastructure</span>
        </div>
        <div class="content row row-cols-2 row-md-12 align-items-start align-items-md-center justify-content-center justify-content-xl-around  "
            style="padding-bottom: 1rem;">
            <div class="imgs col-5 col-lg-4 equipment-img">
                <img src="../../assets/images/hospital-infrastructure.svg" alt="equipments"
                    class="img-fluid d-block d-lg-none" height="auto">
                <img src="../../assets/images/hospital-infrastructure.svg" alt="equipments" class="d-none d-lg-block"
                    width="300px" height="auto">
                <p class="infraName">Total Rooms: <span style="color: rgba(64, 64, 64, 1)"> {{ (infras?.totalRooms === 0
                        || infras?.totalRooms === null) ? 0 : infras?.totalRooms }} </span> </p>
            </div>
            <div class="imgs col-5 col-lg-4 equipment-img">
                <img src="../../assets/images/icons/hospital-infra1.svg" alt="equipments"
                    class="img-fluid d-block d-lg-none" height="auto">
                <img src="../../assets/images/icons/hospital-infra1.svg" alt="equipments" class="d-none d-lg-block"
                    width="300px" height="auto">
                <p class="infraName">Total ICU Rooms: <span style="color: rgba(64, 64, 64, 1)"> {{
                        (infras?.totalIcuRooms === 0 || infras?.totalIcuRooms === null) ? 0 : infras?.totalIcuRooms }}
                    </span> </p>
            </div>
            <div class="imgs col-5 col-lg-4 equipment-img">
                <img src="../../assets/images/icons/hospital-infra2.svg" alt="equipments"
                    class="img-fluid d-block d-lg-none" height="auto">
                <img src="../../assets/images/icons/hospital-infra2.svg" alt="equipments" class="d-none d-lg-block"
                    width="300px" height="auto">
                <p class="infraName">Total Beds: <span style="color: rgba(64, 64, 64, 1)"> {{ (infras?.totalBeds === 0
                        || infras?.totalBeds === null) ? 0 : infras?.totalBeds }} </span> </p>
            </div>
            <div class="imgs col-5 col-lg-4 equipment-img">
                <img src="../../assets/images/icons/hospital-infra3.svg" alt="equipments"
                    class="img-fluid d-block d-lg-none" height="auto">
                <img src="../../assets/images/icons/hospital-infra3.svg" alt="equipments" class="d-none d-lg-block"
                    width="300px" height="auto">
                <p class="infraName">Patient Capacity: <span style="color: rgba(64, 64, 64, 1)"> {{
                        (infras?.patientCapacity === 0 || infras?.patientCapacity === null) ? 0 :
                        infras?.patientCapacity }} </span> </p>
            </div>
        </div>
    </div>

    <div class="doctors">
        <div class="heading team-meet">
            <h2 class="libra" style="color: #484848;">MEET OUR TEAM OF</h2>
            <span class="contact-heading headline header libra mb-3">Healthcare Experts</span>
        </div>
        <div class="arrowsContainer" *ngIf="clinicsData?.members?.length > 0; else noDoctors ">
            <img [ngClass]="{'disabled': !canSlideLeftDoctors}" class="d-none d-sm-block d-lg-block"
                src="assets/images/specialities_left-arrow.svg" alt="Left Arrow"
                (click)="slide('left','clinic-imgs-container')" style="cursor: pointer;">
            <div class="cards ">
                <div class="clinic-imgs-container" [ngClass]="containerClass">
                    <div class="card  doc-card" *ngFor="let doctor of clinicsData?.members">

                        <div class="image-wrapper">

                            <img *ngIf="doctor.image; else noImage" class="doctor-img" [src]="doctor.image"
                                alt="profile pic" width="160px" height="160px">

                            <ng-template #noImage>
                                <div class="fallback-img"> {{ getInitial(doctor?.name) }}</div>
                            </ng-template>
                        </div>
                        <div class="info">
                            <span class="name">
                                <span class="dr"></span>
                                <span class="n">{{ doctor?.name }}</span>
                            </span>
                            <p class="designation" style="white-space: normal; text-align: center; ">
                                {{ doctor?.position?.name }}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <img [ngClass]="{'disabled': !canSlideRightDoctors}" class="d-none d-sm-block d-lg-block"
                src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                (click)="slide('right','clinic-imgs-container')" style="cursor: pointer;">
        </div>
        <ng-template #noDoctors>
            <p class="to-be-updated">To be Updated soon</p>
        </ng-template>
    </div>


    <div class="d-flex align-items-center justify-content-center text-center specialities">
        <div class="equipmentsSpecialities specialities-data"
            style="margin: 30px 23px !important; border: 1px solid black; padding: 10px; border-radius: 11px; background: white; ">
            <div class="">
                <span class="contact-heading libra headerTitleNext">Our Specialities</span>
            </div>
            <div class="clinic-speciality-conatiner" *ngIf="specialitiesData.length > 0; else noData" style>
                <img class="d-none d-sm-block d-lg-block" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left', 'specialityContainer')"
                    [class.disabled]="!canSlideLeftSpecialities" style="cursor: pointer; width: 40px; height: auto;">
                <div class="content-speciality d-flex align-items-center">
                    <div class="imgs-containerSpeciality row-cols-2 row-sm row-lg d-flex d-sm-flex d-lg-flex flex-sm-row flex-lg-row overflow-hidden specialityContainer">
                        <div class="imgSpeciality speciality-items" *ngFor="let speciality of specialitiesData">
                            <img [src]="speciality[1]" alt="equipments" width="60px" height="60px" class="imgImage">
                            <p class="infraName">
                                <span *ngFor="let line of splitText(speciality[0])">
                                    {{ line }}<br>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <img class="d-none d-sm-block d-lg-block clicnic-right-arrow"
                    src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                    (click)="slide('right', 'specialityContainer')" [class.disabled]="!canSlideRightSpecialities"
                    style="cursor: pointer; width: 40px; height: auto;">
            </div>
            <ng-template #noData>
                <p class="to-be-updated">To be Updated Soon</p>
            </ng-template>
        </div>
    </div>

    <div class="equipments advanced-equipment" style="background-color: rgba(225, 241, 255, 1);">
        <div class="heading headline our-advanced p-0 p-md-4 text-center">
            <h2 class="mt-3 libra" style="color:#484848; padding-bottom:5px;">OUR ADVANCED</h2>
            <span class="contact-heading header libra" style="margin-top: 0px;">Medical Equipments</span>
        </div>
        <div class="sliderContainer" *ngIf="clinicsData?.equipments?.length > 0; else noData">
            <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                alt="Left Arrow" (click)="slide('left', 'ourAdvanced-container')"
                [class.disabled]="!canSlideLeftEquipments" style="cursor: pointer; width: 40px; height: auto;">

            <div class="equipementImgs-container  ourAdvanced-container"
                [class.scroll]="equipmentsData.length > 5 || (isSmallScreen && equipmentsData.length > 0)">
                <ng-container *ngFor="let equipment of equipmentsData">
                    <div class="imgsEquipments col-5 ">
                        <img [src]="equipment.imageUrl" alt="equipments" class="d-block d-md-none img-fluid imgMobile"
                            style="object-fit: cover; width: 100%; max-height: 250px;">
                        <img [src]="equipment.imageUrl" alt="equipments" class="d-none d-md-block" width="300px"
                            height="250px">
                        <p class="infraName">{{ equipment.name }}</p>
                    </div>
                </ng-container>
            </div>

            <img class="d-none d-sm-block d-lg-block" src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                (click)="slide('right', 'ourAdvanced-container')" [class.disabled]="!canSlideRightEquipments"
                style="cursor: pointer; width: 40px; height: auto;">
        </div>
        <ng-template #noData>
            <p class="to-be-updated">To be Updated Soon</p>
        </ng-template>
    </div>

    <div style="width: 100%; background: white;">
        <div class="clinic-achievements-container">
            <div class="achievements ">
                <div class="heading p-0 p-md-4">
                    <h2 class="libra achievments-title">ACHIEVEMENTS & CONTRIBUTIONS</h2>
                    <span class="contact-heading libra text-sm-center text-md-auto "
                        style="margin-top: 0px; text-align: center;">Recognized Excellence in Healthcare</span>
                        <p class="sub-text-title libra">
                            Honoring milestones, published works, and community efforts that define our commitment to healthcare excellence.
                        </p>
                </div>                
            </div>
            <div class="clinic-acheivements">
                <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left','cards-content-container')" [class.disabled]="!canSlideLeftAcheivements"
                    style="cursor: pointer; width: 40px; height: auto;">
                <div class="t t1 col-12 d-flex align-items-center flex-column d-md-flex flex-md-row align-items-md-start" class="cards-content-container">
                    <div class="clinic-acheivements-contributions">
                        <h2 class="clinic-acheivement-card-title">Publications</h2>
                        <div *ngIf="publications && publications.length !== 0" class="publications-scroll-container">
                          <span *ngFor="let publication of publications" class="publications-inner">
                            <div class="clinic-content-container">
                              <p class="data-title">{{ publication.title }}</p>
                              <p class="clinic-acheivement-label">
                                Published by: 
                                <span class="clinic-acheivement-value">{{ publication.publishedby }}</span>
                              </p>
                            </div>
                          </span>
                        </div>
                        <div *ngIf="!publications || publications.length === 0" 
                             style="display: flex; align-items: center; justify-content: center; height: 100%;">
                          <p class="to-be-updated">To Be Updated Soon</p>
                        </div>
                      </div>
                    <div class="clinic-acheivements-contributions">
                        <h2 class="clinic-acheivement-card-title">Awards & Honors</h2>
                        <div *ngIf="awards && awards.length !== 0" class="publications-scroll-container">
                          <span *ngFor="let award of awards" class="publications-inner">
                            <div class="clinic-content-container">
                              <p class="data-title">{{ award.title }}</p>
                              <p class="clinic-acheivement-label">
                                Awarded by: 
                                <span class="clinic-acheivement-value">{{ award.association }}</span>
                              </p>
                            </div>
                          </span>
                        </div>
                        <div *ngIf="!awards || awards.length === 0" 
                             style="display: flex; align-items: center; justify-content: center; height: 100%;">
                          <p class="to-be-updated">To Be Updated Soon</p>
                        </div>
                    </div>
                    <div class="clinic-acheivements-contributions">
                        <h2 class="clinic-acheivement-card-title">Associations & Organizations</h2>
                        <div *ngIf="associations && associations.length !== 0" class="publications-scroll-container">
                          <span *ngFor="let association of associations" class="publications-inner">
                            <div class="clinic-content-container">
                              <p class="data-title">{{ association.associationName }}</p>
                              <p class="clinic-acheivement-label">
                                Position:
                                <span class="clinic-acheivement-value">{{ association.positionHeld }}</span>
                              </p>
                              <p class="clinic-acheivement-label">
                                From:
                                <span class="clinic-acheivement-value">
                                  {{ association.fromDate | date:'MM/dd/yyyy' }} to {{ association.toDate | date:'MM/dd/yyyy' }}
                                </span>
                              </p>
                            </div>
                          </span>
                        </div>
                        <div *ngIf="!associations || associations.length === 0" 
                             style="display: flex; align-items: center; justify-content: center; height: 100%;">
                          <p class="to-be-updated">To Be Updated Soon</p>
                        </div>
                      </div>
                    <div class="clinic-acheivements-contributions">
                        <h2 class="clinic-acheivement-card-title">Volunteering & Causes</h2>
                        <div *ngIf="volunteerings && volunteerings.length !== 0" class="publications-scroll-container">
                          <span *ngFor="let volunteering of volunteerings" class="publications-inner">
                            <div class="clinic-content-container">
                              <p class="data-title">{{ volunteering.organizationName }}</p>
                              <p class="clinic-acheivement-label">
                                Position: <span class="clinic-acheivement-value">{{ volunteering.positionHeld }}</span>
                              </p>
                              <p class="clinic-acheivement-label">
                                From: 
                                <span class="clinic-acheivement-value">
                                  {{ volunteering.fromDate | date:'MM/dd/yyyy' }} to {{ volunteering.toDate | date:'MM/dd/yyyy' }}
                                </span>
                              </p>
                            </div>
                          </span>
                        </div>
                        <div *ngIf="!volunteerings || volunteerings.length === 0" 
                             style="display: flex; align-items: center; justify-content: center; height: 100%;">
                          <p class="to-be-updated">To Be Updated Soon</p>
                        </div>
                    </div>
                </div>
                <img class="d-none d-sm-block d-lg-block" src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                (click)="slide('right','cards-content-container')" [class.disabled]="!canSlideRightAcheivements"
                    style="cursor: pointer; width: 40px; height: auto;">                 
            </div>
        </div>
    </div>

    <div class="lookat" *ngIf="clinicsData?.photos?.length !== 0 || !isMobileView">
        <div class="outer-lookat">
            <div class="inner-lookat">
                <span class="lookat-heading libra">HAVE A LOOK AT</span>
                <span class="lookat-subtitle libra">Our Facilities & Latest Activities </span>
            </div>
        </div>
        <div class="l">
            <div class="inner-l">
                <div class="small col-5 col-lg-auto m-1 " *ngFor="let photo of clinicsData?.photos"
                    style="max-width:260px;">
                    <img [src]="photo?.photoLink" alt="small0" class="img-fluid d-block d-sm-none d-md-none"
                        style="width:-webkit-fill-available;">
                    <img [src]="photo?.photoLink" alt="small0" class="d-none d-sm-block d-md-none col-12"
                        height="280px">
                    <img [src]="photo?.photoLink" alt="small0" class="d-none d-sm-none d-md-block " width="260px"
                        height="280px">
                </div>
            </div>
            <img src="../../assets/images/hospital-lookatr.svg" alt="r" class="d-none d-xl-block" width="320px"
                height="100%">
        </div>
    </div>
</div>
<app-website-footer></app-website-footer>